import { createElement } from "@max/max";
import { Skeleton } from '@nibfe/marketing-blocks-universal';
import View from '@hfe/max-view';
import { SHOW_TYPE_ENUM } from '../constants';
import Image from '@hfe/max-image';
export default (props) => {
    const skData = '{"type":"Buffer","data":[1,1,119,1,70,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,0,172,0,171,0,133,0,255,255,255,255,0,192,0,172,0,171,0,133,0,255,255,255,255,1,45,1,6,0,52,0,30,0,255,244,244,244,0,202,1,24,0,31,0,10,0,255,244,244,244,0,202,1,2,0,58,0,17,0,255,244,244,244,0,202,0,241,0,38,0,10,0,255,244,244,244,0,12,0,44,0,171,0,128,0,255,255,255,255,0,192,0,44,0,171,0,128,0,255,255,255,255,0,21,0,179,0,131,0,14,0,255,244,244,244,0,202,0,179,0,148,0,14,0,255,244,244,244,0,21,0,199,0,151,0,14,0,255,244,244,244,0,202,0,199,0,151,0,14,0,255,244,244,244,0,202,0,218,0,146,0,11,0,255,244,244,244,0,22,0,218,0,146,0,11,0,255,244,244,244,0,22,0,236,0,31,0,17,0,255,244,244,244,0,22,1,2,0,58,0,17,0,255,244,244,244,0,122,1,6,0,52,0,30,0,255,244,244,244,0,22,1,24,0,31,0,10,0,255,244,244,244,0,61,0,241,0,38,0,10,0,255,244,244,244,0,12,1,186,0,171,0,133,0,255,255,255,255,0,192,1,186,0,171,0,133,0,255,255,255,255,1,45,2,20,0,52,0,30,0,255,244,244,244,0,202,2,38,0,31,0,10,0,255,244,244,244,0,202,2,16,0,58,0,17,0,255,244,244,244,0,202,1,255,0,38,0,10,0,255,244,244,244,0,12,1,58,0,171,0,128,0,255,255,255,255,0,192,1,58,0,171,0,128,0,255,255,255,255,0,21,1,193,0,131,0,14,0,255,244,244,244,0,202,1,193,0,148,0,14,0,255,244,244,244,0,21,1,213,0,151,0,14,0,255,244,244,244,0,202,1,213,0,151,0,14,0,255,244,244,244,0,202,1,232,0,146,0,11,0,255,244,244,244,0,22,1,232,0,146,0,11,0,255,244,244,244,0,22,1,250,0,31,0,17,0,255,244,244,244,0,22,2,16,0,58,0,17,0,255,244,244,244,0,122,2,20,0,52,0,30,0,255,244,244,244,0,22,2,38,0,31,0,10,0,255,244,244,244,0,61,1,255,0,38,0,10,0,255,244,244,244]}';
    return props.showType === SHOW_TYPE_ENUM.TWO_LIST ? <View style={{
            backgroundColor: '#F4F4F4',
            overflow: 'hidden'
        }}>
        <View style={{
            marginTop: '-40rpx'
        }}>
          <Skeleton width={'750rpx'} height={'1200rpx'} skeletonData={skData}/>
        </View>
      </View> : <View style={{
            backgroundColor: '#F4F4F4',
            overflow: 'hidden',
            paddingTop: '25rpx',
            paddingBottom: '15rpx',
            paddingLeft: '13rpx'
        }}>
        <Image style={{
            width: '750rpx',
            height: '490rpx'
        }} source={{
            uri: 'https://img.meituan.net/makerjiulv/88a1063ce8b99dc7e15798eda19db9248512.png'
        }}/>
      </View>;
};
